import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SelectReact from 'react-select';

import { availabilityColorStyles } from '../../assets/stylesheets/ReactSelectStyles';

class BookingFormSelect extends Component {

  getValues(options){
    return options.reduce((result,opt)=>{
      if(opt.options){
        return result.concat(this.getValues(opt.options))
      }
      if(opt.isSelected){
        return result.concat([opt])
      }
      return result;
    }, []);
  }

  handleOnChange = (selectedModels) => {
    const {
      onChange,
      position
    } = this.props;
    onChange(position, selectedModels);
  }

  handleOnFocus = () => {
    const {
      onFocus,
      position
    } = this.props;
    onFocus(position);
  }

  render() {
    const {
      options,
    } = this.props;

    return (
      <SelectReact
        fullWidth
        isMulti
        hideSelectedOptions
        menuShouldScrollIntoView={false}
        className="bookingSelectField"
        value={this.getValues(options)}
        options={options}
        onChange={this.handleOnChange}
        onFocus={this.handleOnFocus}
        styles={availabilityColorStyles}
      />
    )
  }
}

BookingFormSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  position: PropTypes.string.isRequired
}

export default BookingFormSelect;